import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'

export function useHistoricalPriceDeal() {
  const pickers = useFetchPickers()
  const experiments = useExperiments()

  const historicalPrice = computed(() => {
    if (
      experiments['experiment.ppJapanHistoricalPrice'] !== 'withHistoricalPrice'
    ) {
      return null
    }

    const selectedOffer = pickers.selectedOffer.value

    // pickers API promised not resolved yet or price is unset.
    if (!selectedOffer || !selectedOffer.price) {
      return null
    }

    const deal = selectedOffer.deals?.find((d) => d.type === 'historical_price')

    // No 'historical price', or malformed deal 'historical price' deals (supposed to have a 'referencePrice').
    if (!deal || !deal.referencePrice) {
      return null
    }

    // Mixed currencies operations are not defined.
    if (deal.referencePrice.currency !== selectedOffer.price.currency) {
      return null
    }

    const dealReferencePriceNumber = deal.referencePrice.amount
    const selectedOfferPriceNumber = parseFloat(selectedOffer.price.amount)

    if (dealReferencePriceNumber === 0) {
      return null
    }

    // Example: current=377 vs reference=400 => differencePrice=23
    const differencePriceNumber =
      dealReferencePriceNumber - selectedOfferPriceNumber

    // Using 'floor' because if the exact difference is 5.8%, it's wrong to say that the current
    // price is 6% cheaper than the reference price but it's correct to say that it's 5% cheaper
    // (and it's even a bit more).
    // Example: current=377 vs reference=400 => differencePercentage=5
    // APAC-1150: This is duplicated with product-core jp, let's try to dedup this (shared FE utils
    // or move to popularity-stats)
    const differencePercentage = Math.floor(
      (differencePriceNumber / dealReferencePriceNumber) * 100,
    )

    return {
      referencePrice: {
        amount: deal.referencePrice.amount.toString(),
        currency: deal.referencePrice.currency,
      },
      differencePercentage,
    }
  })

  return { historicalPrice }
}
